import { useQuery } from '@tanstack/react-query';
import { ConfigurationService } from '../services/configuration.service';

export function useProviderDefaultStripeLink() {
  return useQuery({
    queryKey: ['provider-default-stripe-link'],
    queryFn: () => ConfigurationService.getProviderDefaultStripeLink(),
    select: (data) => data.provider_default_stripe_link,
  });
}
